import {
  AfterViewInit,
  Component,
  DestroyRef,
  ElementRef,
  inject,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AUTH_INITIALIZATION_ERROR } from '../../../utils/auth-initialization-error';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { getFeedback } from '@sentry/angular';
import {
  getSentryFeedbackText,
  SENTRY_FEEDBACK_TRANSLATION_KEYS,
} from '../../../utils/sentry';
import { ProductPlacementComponent } from '../../product-placement/product-placement.component';

@Component({
  selector: 'app-login-error',
  imports: [TranslatePipe, ProductPlacementComponent],
  templateUrl: './login-error.component.html',
  styleUrl: './login-error.component.scss',
})
export class LoginErrorComponent implements AfterViewInit, OnDestroy {
  private readonly feedback = getFeedback();
  private readonly translate = inject(TranslateService);
  private readonly destroyRef = inject(DestroyRef);
  private detachFeedback?: () => void;
  protected readonly feedbackAvailable = !!this.feedback;
  @ViewChild('reportButton')
  private reportButton?: ElementRef<HTMLButtonElement>;
  private readonly fragmentParams = new URLSearchParams(
    inject(AUTH_INITIALIZATION_ERROR)() ?? '',
  );
  protected readonly errorCode = this.fragmentParams.get('error');
  protected readonly errorDescription =
    this.fragmentParams.get('error_description');

  ngAfterViewInit(): void {
    if (!this.feedback || !this.reportButton) {
      return;
    }
    this.translate
      .stream(SENTRY_FEEDBACK_TRANSLATION_KEYS)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((translations) => {
        this.detachFeedback?.();
        this.detachFeedback = this.feedback!.attachTo(
          this.reportButton!.nativeElement,
          {
            ...getSentryFeedbackText(translations),
            tags: {
              source: 'login-error',
              auth_error: this.errorCode,
              auth_error_description: this.errorDescription,
            },
          },
        );
      });
  }

  ngOnDestroy(): void {
    this.detachFeedback?.();
  }
}
